// Supported languages for article translation. Codes must match
// ArticleTranslation.LANGUAGE_CHOICES in backend/apps/articles/models.py.
export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'ar', label: 'العربية' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'ur', label: 'اردو' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'zh', label: '中文' },
  { code: 'bn', label: 'বাংলা' },
];

export const RTL_LANGUAGES = ['ar', 'ur'];
